var map = {
	"./adult/nn/2 1 ordkjedetekst.mp3": 727,
	"./adult/no/2 1 ordkjedetekst.mp3": 728,
	"./adult/se/2 1 ordkjedetekst.mp3": 729,
	"./youth/de/2 1 ordkjedetekst.mp3": 730,
	"./youth/nn/2 1 ordkjedetekst.mp3": 731,
	"./youth/no/2 1 ordkjedetekst.mp3": 732,
	"./youth/se/2 1 ordkjedetekst.mp3": 733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 726;